import styled from 'styled-components';

export const FooterSection = styled.footer`
  background: #145A5A;
  color: white;
  padding: 3rem 0 1rem;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

export const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const FooterSectionItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FooterTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: #fbbf24;
`;

export const FooterSubtitle = styled.span`
  font-size: 1rem;
  color: #94a3b8;
  margin-bottom: 1rem;
  font-weight: 500;
`;

export const FooterDescription = styled.p`
  font-size: 0.875rem;
  line-height: 1.6;
  color: #cbd5e1;
  margin-bottom: 1rem;
`;

export const ContactList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const ContactIcon = styled.div`
  font-size: 1rem;
  color: #197278;
  flex-shrink: 0;
`;

export const ContactText = styled.span`
  font-size: 0.875rem;
  color: #cbd5e1;
  a {
    color: #fff;
    text-decoration: underline;
    transition: color 0.2s;
  }
  a:hover {
    color: #fbbf24;
  }
`;

export const ServicesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ServiceItem = styled.span`
  font-size: 0.875rem;
  color: #cbd5e1;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #197278;
  }
`;

export const FooterBottom = styled.div`
  border-top: 1px solid #334155;
  padding-top: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const Copyright = styled.p`
  font-size: 0.875rem;
  color: #94a3b8;
`;

export const MadeWith = styled.p`
  font-size: 0.875rem;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  svg {
    color: #ef4444;
  }
`; 